// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header_KfC-k","logo":"Header_logo_1IcI1"};